import store from "../store";
import { env } from "./env";

export let cookie = {
	set(name, value, days, domain = getDomain()) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    const domainStr = domain ? "; domain=" + domain : "";
    document.cookie = name + "=" + (value || "") + expires + domainStr + "; path=/";
  },
	get(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(";");
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == " ") c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	},
	delete(name) {
		document.cookie = name + "=; Max-Age=-99999999;";
	},
	
};

function getDomain() {
  const hostname = window.location.hostname;
  
  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return null;
  }
  
  // Surge.sh domains
  if (hostname.includes('.surge.sh')) {
    return hostname; // Return the full surge domain
  }
  
  // Production domain
  return '.betika.com';
}

export function getParameterByName(name, url) {
	url = window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return "";
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function getAppSource() {
	let utm = store.getters.utmInfo;
	if (utm == null) {
		return getDefaultAppSource();
	}

	if (utm.medium !== undefined) {
		if (utm.medium == "speed_dial_v1") {
			return "OPERA_SDV1";
		} else if (utm.medium == "speed_dial_v2") {
			return "OPERA_SDV2";
		} else {
			return getDefaultAppSource();
		}
	}

	return getDefaultAppSource();
}

function getDefaultAppSource() {
	return window.APP_SRC;
}

export function focusAndOpenKeyboard(el, timeout) {
	if (!timeout) {
		timeout = 100;
	}
	if (el) {
		// Align temp input element approximately where the input element is
		// so the cursor doesn't jump around
		var __tempEl__ = document.createElement("input");
		__tempEl__.style.position = "absolute";
		__tempEl__.style.top = el.offsetTop + 7 + "px";
		__tempEl__.style.left = el.offsetLeft + "px";
		__tempEl__.style.height = 0;
		__tempEl__.style.opacity = 0;
		// Put this temp element as a child of the page <body> and focus on it
		document.body.appendChild(__tempEl__);
		__tempEl__.focus();

		// The keyboard is open. Now do a delayed focus on the target element
		setTimeout(function() {
			el.focus();
			el.click();
			// Remove the temp element
			document.body.removeChild(__tempEl__);
		}, timeout);
	}
}

export function validatePhoneNumber(phone) {
	const regex = new RegExp(MOBILE_REGEX);
	return regex.test(phone);
}

export function getNumberPrefix(number) {
	let numberRegex = "^(\\+){0,1}(\\d{3})(\\d*)$";
	const regex = new RegExp(numberRegex);
	let matches = regex.exec(number);
	return matches ? matches[2] : undefined; //index 0 is a match of the entire string, group matches start at index 1
}


export function formatMobile(number) {
	let regex = MOBILE_REGEX;
	let mobilePrefix = MOBILE_PREFIX;
	let formattedNumber = "";

	let matches = number.match(regex);

	// Check if there are any matches
	if (matches) {
		formattedNumber = `${mobilePrefix}${matches[2]}`;
		return formattedNumber;
	} else {
		return null;
	}
}

export function getPrefixCountry(prefix) {
	if (prefix in env.msisdnPrefix) {
		return env.msisdnPrefix[prefix];
	} else {
		return null;
	}
}

export async function hashString(sensitiveInfo) {
	const hashBytes = await crypto.subtle.digest(
		"SHA-256",
		new TextEncoder().encode(sensitiveInfo)
	);
	return Array.prototype.map
		.call(new Uint8Array(hashBytes), (byte) =>
			byte.toString(16).padStart(2, "0")
		)
		.join("");
}

export function formatMobileNumber(number) {
	// Remove spaces and plus sign
	const removedSpacesAndPlus = number.replace(/[d\+]|[ ]/g, "");
	const regex = /^(?:\+?(?:[1-9]{3})|0)?(7|1)([0-9]{8})$/;
	let msisdn = removedSpacesAndPlus;
	const capture = regex.exec(removedSpacesAndPlus);
	if (capture) {
		msisdn = env.prefix + capture[1] + capture[2];
	}
	return msisdn;
}



export function getUrlSlug(input){
	let	unicodeToAscii = function(inputString) {
		// Normalize the input string to handle different Unicode representations
		const normalized = inputString.normalize("NFD");

		// Use regular expressions to replace or remove diacritics
		const asciiString = normalized.replace(/[\u0300-\u036f]/g, ""); // Range covers most diacritics

		return asciiString;
	}

	let formatted = unicodeToAscii(input);
	let slug = formatted.toLowerCase()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "");

	return slug;
}
